module.exports = {
  getUserIP: async () => {
    try {
      const response = await fetch("https://api.ipify.org?format=json");
      const data = await response.json();
      return data.ip;
    } catch (error) {
      console.error("Failed to get IP:", error);
      return null;
    }
  },

  getCardType: (cardNumber) => {
    if (!cardNumber) return "Unknown";

    const cleaned = cardNumber.replace(/[\s-]/g, "");

    if (/^4/.test(cleaned)) return "Visa";
    if (/^5[1-5]/.test(cleaned) || /^2[2-9]/.test(cleaned)) return "Mastercard";

    return "Unknown";
  },

  formatDateTime: (input) => {
    const date = new Date(input?.replace(" ", "T"));
    const options = { day: "2-digit", month: "long", year: "numeric" };
    const datePart = date.toLocaleDateString("en-US", options);
    const timePart = date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    return `${datePart}, ${timePart}`;
  },

  getDateRangeUnix: (fromDateString, toDateString) => {
    const fromDate = new Date(fromDateString);
    const toDate = new Date(toDateString);
  
    const dateFrom = Math.floor(fromDate.getTime() / 1000); 
    const dateTo = Math.floor(toDate.getTime() / 1000);
  
    return {
      date_from: dateFrom,
      date_to: dateTo,
    };
  },
};
